/* eslint-disable no-unused-vars */

import React from 'react';
import _ from 'lodash';

import Textarea from '@components/textarea';
import TextBoxUnit from '@components/text-box-unit';
import InputField from '@components/input-field';
import Datepicker from '@components/date-picker-component';
import Select from '@components/select-box-component';
import HierarchicalDropdown from '@components/hierarchical-dropdown/hierarchical-dropdown';

import FormCheckbox from '@components/work-order/components/checkbox';

import style from './style.module.scss';

const MapField = ({
  field,
  isInputReconcile,
  isSelectBoxReconcile,
  isTextBoxUnitReconcile,
  errors,
  register,
  watch,
  getValues,
  control,
  setValue,
  showReconcileFeatherIconWhenValueChanged = false,
  moreInfoOfPSVs = [],
  moreFields = false
}) => {
  return (
    <div>
      {(field?.type === 'Text' || field?.type === 'Numeric' || field?.type === 'PhoneNumber') && (
        <div className="op-input-field-wrap">
          <InputField
            showErrorMessage={!field?.isMasterData}
            label={field?.label}
            dot={field?.required}
            type={
              field?.type === 'Text' || field?.type === 'PhoneNumber'
                ? 'text'
                : field?.type === 'Numeric'
                ? 'number'
                : 'text'
            }
            step={field?.type === 'Numeric' ? 'any' : undefined}
            telephone={field?.type === 'PhoneNumber'}
            inputClass="input-field input-regular"
            labelColor={style.labelColor}
            className={field?.isReadOnly ? style.disabledColor : ''}
            register={register}
            name={field?.name}
            error={errors[field?.name]?.message ? 'Required' : ''}
            disabled={field?.isReadOnly}
            reconciled={field?.isMasterData}
            showReconciled={
              isInputReconcile &&
              isInputReconcile({
                fieldName: field?.name,
                isMasterData: field?.isMasterData,
                isNumber: field?.type === 'Numeric'
              })
            }
            showReconcileFeatherIconWhenValueChanged={showReconcileFeatherIconWhenValueChanged}
          />
        </div>
      )}
      {(field?.type == 'Dropdown' || field?.type == 'Dropdown_PL') && (
        <Select
          showErrorMessage={!field?.isMasterData}
          dot={field?.required}
          label={field?.label}
          options={field?.options}
          labelColor={style.labelColor}
          control={control}
          name={field?.name}
          error={
            moreFields && errors?.['moreFields']?.[field.fieldName]?.[field.Id]?.message
              ? 'Required'
              : errors[field?.name]?.message
              ? 'Required'
              : ''
          }
          register={register}
          isClearable
          disabled={field?.isReadOnly}
          reconciled={field?.isMasterData}
          showReconciled={
            isSelectBoxReconcile &&
            isSelectBoxReconcile({
              fieldName: field?.name,
              isMasterData: field?.isMasterData,
              options: field?.options
            })
          }
          showReconcileFeatherIconWhenValueChanged={showReconcileFeatherIconWhenValueChanged}
        />
      )}

      {field?.type === 'HierarchicalDropdown' && (
        <HierarchicalDropdown
          showErrorMessage={!field?.isMasterData}
          options={
            moreInfoOfPSVs?.length > 0
              ? field?.options?.filter((x) => x?.allowedForPVCreation)
              : field?.options
          }
          dot={field?.required}
          label={field?.label}
          name={field?.name}
          error={errors[field?.name]?.message ? 'Required' : ''}
          disabled={field?.isReadOnly}
          reconciled={field?.isMasterData}
          showReconciled={
            !_.isEmpty(watch(`${field?.name}-reconcile`)) &&
            field?.isMasterData &&
            field?.options?.length > 0 &&
            watch(`${field?.name}-reconcile`) !== watch(field?.name)
              ? true
              : false
          }
          setValue={setValue}
          defaultValue={getValues(field?.name)}
          equipmentCategoryTypeSubtype
          showReconcileFeatherIconWhenValueChanged={showReconcileFeatherIconWhenValueChanged}
        />
      )}

      {(field?.type === 'Date' || field?.type === 'Date_Nullable') && (
        <Datepicker
          backClass={style.datePicker2}
          id={'psvDate'}
          label={field?.label}
          inputClass="input-regular op-datepicker"
          control={control}
          name={field?.name}
          error={errors[field?.name]?.message ? 'Required' : ''}
          register={register}
          isClearable
          readOnly={true}
          dot={field?.required}
          showReconcileFeatherIconWhenValueChanged={showReconcileFeatherIconWhenValueChanged}
        />
      )}

      {(field?.type === 'Readings' || field?.type === 'Readings_PL') && (
        <TextBoxUnit
          inputLabel={`${field?.label}`}
          control={control}
          register={register}
          inputFiledRequired={field?.required}
          setValue={setValue}
          watch={watch}
          error={
            moreFields &&
            (errors?.['moreFields']?.[field.fieldName]?.[field.Id]?.textBoxValue?.message ||
              errors?.['moreFields']?.[field.fieldName]?.[field.Id]?.textBoxUnitValue?.message)
              ? 'Required'
              : errors[field?.name]?.textBoxValueErrors?.message ||
                errors[field?.name]?.textBoxUnitValueErrors?.message
              ? 'Required'
              : null
          }
          textBoxValueError={
            errors?.['moreFields']?.[field.fieldName]?.[field.Id]?.textBoxValue?.message ||
            errors[field?.name]?.textBoxValueErrors?.message
              ? true
              : false
          }
          textBoxUnitValueError={
            errors?.['moreFields']?.[field.fieldName]?.[field.Id]?.textBoxUnitValue?.message ||
            errors[field?.name]?.textBoxUnitValueErrors?.message
              ? true
              : false
          }
          name={field?.name}
          options={field?.options}
          reconciled={field?.isMasterData}
          showReconciled={
            isTextBoxUnitReconcile &&
            isTextBoxUnitReconcile({
              fieldName: field?.name,
              isMasterData: field?.isMasterData
            })
          }
          showReconcileFeatherIconWhenValueChanged={showReconcileFeatherIconWhenValueChanged}
        />
      )}
      {field?.type == 'LongText' && (
        <Textarea
          dot={field?.required}
          label={field?.label}
          inputClass="input-field input-regular"
          labelColor={style.labelColor}
          register={register}
          name={field?.name}
          error={errors[field?.name]?.message ? 'Required' : ''}
          isRequiredMsg={'Required'}
          reconciled={field?.isMasterData}
          showReconciled={
            isInputReconcile &&
            isInputReconcile({
              fieldName: field?.name,
              isMasterData: field?.isMasterData
            })
          }
          showReconcileFeatherIconWhenValueChanged={showReconcileFeatherIconWhenValueChanged}
        />
      )}

      {field?.type == 'YN' && (
        <FormCheckbox
          field={field}
          // count={count}
          value={watch(field?.name) || false}
          name={field?.name}
          label={field?.label}
          setValue={setValue}
        />
      )}
    </div>
  );
};

export default MapField;
